import { render, staticRenderFns } from "./AppointmentUpdatedToUser.vue?vue&type=template&id=ad231aca"
import script from "./AppointmentUpdatedToUser.vue?vue&type=script&lang=js"
export * from "./AppointmentUpdatedToUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports